export enum OrderLineType {
  Fee,
  GiftCard,
  SingleProduct,
  EventProduct,
  AdditionalProduct,
  AutomaticAdditionalProduct,
  Deposits,
  Product,
  CustomGiftCard,
}
